import { format } from "../../../utils";

const mapCard = (json) => {
	const {
		productName,
		productDesc,
		hsnCode,
		quantity,
		quantityUnit,
		taxableAmount,
		sgstRate,
		cgstRate,
		igstRate,
	} = json;
	return [
		[{ labels: ["Product"], value: productName, type: "string" }],
		[{ labels: ["Description"], value: productDesc, type: "string" }],
		[{ labels: ["HSN Code"], value: hsnCode, type: "string" }],
		[{ labels: ["Quantity"], value: quantity, type: "number" }],
		[{ labels: ["Quantity Unit"], value: quantityUnit, type: "string" }],
		[
			{
				labels: ["Taxable Amount"],
				value: format(taxableAmount, null, null, 2),
				type: "number",
			},
		],
		[
			{
				labels: ["SGST Rate"],
				value: format(sgstRate, null, null, 2),
				type: "percentage",
			},
		],
		[
			{
				labels: ["CGST Rate"],
				value: format(cgstRate, null, null, 2),
				type: "percentage",
			},
		],
		[
			{
				labels: ["IGST Rate"],
				value: format(igstRate, null, null, 2),
				type: "percentage",
			},
		],
	];
};

const mapper = (json, card, details) => {
	return {
		...json,
		name: json.name,
		shortName: json.name,
		//details: details ? mapDetails(json) : [],
		card: card ? mapCard(json) : [],
	};
};

const header = [
	{
		label: ["Product"],
		align: "left",
		columnName: "productName",
		sortable: false,
	},
	{
		label: ["Description"],
		align: "left",
		columnName: "productDesc",
		sortable: true,
	},
	{
		label: ["HSN Code"],
		align: "left",
		columnName: "hsnCode",
		sortable: false,
	},
	{
		label: ["Quantity"],
		align: "left",
		columnName: "quantity",
		sortable: true,
	},
	{
		label: ["Quantity Unit"],
		align: "left",
		columnName: "quantityUnit",
		sortable: true,
	},
	{
		label: ["Taxable Amount"],
		align: "left",
		columnName: "taxableAmount",
		sortable: true,
	},
	{
		label: ["SGST Rate"],
		align: "left",
		columnName: "sgstRate",
		sortable: true,
	},
	{
		label: ["CGST Rate"],
		align: "left",
		columnName: "cgstRate",
		sortable: true,
	},
	{
		label: ["IGST Rate"],
		align: "left",
		columnName: "igstRate",
		sortable: true,
	},
];

export default {
	map: mapper,
	header,
};
